import { tr } from '../i18n';
import type { PublicCheckoutFunnelNode } from './contract';

// O editor do vendedor grava estes textos quando o campo fica em branco. Eles
// representam "sem texto próprio" e seguem o idioma do comprador.
const editorDefaultAccept = new Set(['sim, quero']);
const editorDefaultReject = new Set(['não, obrigado', 'nao, obrigado']);

function customLabel(label: string, defaults: ReadonlySet<string>): string | undefined {
  const trimmed = label.trim();
  if (trimmed === '' || defaults.has(trimmed.toLocaleLowerCase('pt-BR'))) {
    return undefined;
  }
  return trimmed;
}

export function upsellAcceptLabel(node: Pick<PublicCheckoutFunnelNode, 'acceptLabel'>, cardValue?: string): string {
  const custom = customLabel(node.acceptLabel, editorDefaultAccept);
  if (custom !== undefined) {
    return custom;
  }
  if (cardValue !== undefined && node.acceptLabel.trim() === '') {
    return tr('upsell.addCard', { value: cardValue });
  }
  return tr('upsell.accept');
}

export function upsellRejectLabel(node: Pick<PublicCheckoutFunnelNode, 'rejectLabel'>): string {
  return customLabel(node.rejectLabel, editorDefaultReject) ?? tr('upsell.reject');
}
